import { createActionGroup, props } from '@ngrx/store';
import { UserGroupAcl, UserGroupAclGroups, UserGroupAclMembers } from '@rocksoft/security-sdk';
import { ErrorModel } from '@rocksoft/shared';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const SettingPermissionsResolverActions = createActionGroup({
  source: 'Setting Permissions Resolver',
  events: {
    'UserGroup acl requested': props<{ resourceId: string }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const AccessControlListApiActions = createActionGroup({
  source: 'Access Control List Controller',
  events: {
    'UserGroup acl loaded': props<{ userGroupAcl: UserGroupAcl }>(),
    'UserGroup acl loaded error': props<{ error: ErrorModel }>(),
    'UserGroup acl member put': props<{ aclMember: UserGroupAclMembers }>(),
    'UserGroup acl group put': props<{ aclGroup: UserGroupAclGroups }>(),
  },
});

// ============================================================================
// UI ACTIONS (Group - using createActionGroup)
// ============================================================================

export const UserAclPermissionsUiActions = createActionGroup({
  source: 'User Acl Permissions Component',
  events: {
    'UserGroup acl member put': props<{ aclMember: UserGroupAclMembers }>(),
  },
});

export const GroupAclPermissionsUiActions = createActionGroup({
  source: 'Group Acl Permissions Component',
  events: {
    'UserGroup acl group put': props<{ aclGroup: UserGroupAclGroups }>(),
  },
});
